import React, { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { CourseCard } from "../components/CourseCard";
import { api } from "../lib/data";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 py-16">
        <p className="font-mono text-xs uppercase tracking-widest text-[#00B368] mb-3">All Programs</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-[#0A1914] mb-3">Choose your trading course</h1>
        <p className="text-gray-600 max-w-2xl mb-12">Purchase as many courses as you like — even the same course multiple times. Each active enrollment earns its own weekly payout for 52 weeks.</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((c, i) => <CourseCard key={c.id} course={c} index={i} />)}
        </div>
      </section>
      <Footer />
    </div>
  );
}
